// Which endpoint a signed-in user's own Settings save goes through.
//
// The role is Django's Users.role from GET /api/users/ (the record the server
// checks), not the B2C jobTitle claim ("Customer"), so client and server can't
// disagree. Customers are refused on Staff routes (users/update), so they save
// through the self endpoint PUT /api/users/. Staff, and a missing or unknown
// role, stay on PUT /api/users/update/ for now: it also syncs the name to B2C.
export const CUSTOMER_ROLE = "customer";

export function savesThroughSelfEndpoint(role) {
  return role === CUSTOMER_ROLE;
}

// The only fields a Settings save sends, on both paths. Never email, address
// or utility fields: the self endpoint would write a Staff caller's branch or
// organization address.
export function toSelfEditFields(formData) {
  return {
    first_name: formData.firstName,
    last_name: formData.lastName,
    phone: formData.phone,
  };
}
